(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const REVEALED_CLASS = 'hero__media--revealed';
  const FALLBACK_MS = 3000;

  /**
   * @param {HTMLImageElement} img
   */
  const shouldSkipHeroFade = (img) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    if (document.documentElement.classList.contains('shopify-design-mode')) return true;
    return Boolean(img.closest('[data-shopify-visual-preview]'));
  };

  /**
   * @param {HTMLImageElement} img
   */
  const revealHeroImage = (img) => {
    img.classList.add(REVEALED_CLASS);
  };

  /**
   * Fade in only after decoded pixels are ready so the transition always runs.
   * @param {HTMLImageElement} img
   */
  const revealAfterReady = (img) => {
    const startFade = () => {
      void img.offsetWidth;
      requestAnimationFrame(() => revealHeroImage(img));
    };

    if (typeof img.decode === 'function') {
      img.decode().then(startFade).catch(startFade);
      return;
    }

    startFade();
  };

  /**
   * @param {HTMLImageElement} img
   */
  const bindHeroImage = (img) => {
    if (img.dataset.heroFadeBound === 'true') return;
    img.dataset.heroFadeBound = 'true';

    if (shouldSkipHeroFade(img)) {
      revealHeroImage(img);
      return;
    }

    const fallback = window.setTimeout(() => revealHeroImage(img), FALLBACK_MS);

    const show = () => {
      window.clearTimeout(fallback);
      revealAfterReady(img);
    };

    if (img.complete && img.naturalWidth > 0) {
      show();
      return;
    }

    img.addEventListener('load', show, { once: true });
    img.addEventListener(
      'error',
      () => {
        window.clearTimeout(fallback);
        revealHeroImage(img);
      },
      { once: true }
    );
  };

  /**
   * @param {ParentNode} [root]
   */
  const initHeroMediaFade = (root = document) => {
    root.querySelectorAll?.('.hero img.hero__media').forEach((img) => bindHeroImage(/** @type {HTMLImageElement} */ (img)));
  };

  initHeroMediaFade();

  document.addEventListener('shopify:section:load', (event) => {
    initHeroMediaFade(/** @type {Event & { target: ParentNode }} */ (event).target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
